// extracted by mini-css-extract-plugin
export default {"container":"ILpjTj","leftContainer":"bYU1qt","rightContainer":"QDAXlS","detailsContainer":"ssCxT6","banner":"FONLl8"};